.restrictedDescription {
  padding: 12px;
  color: var(--color-white);
  opacity: 0.6;
  font-size: 1.6rem;
  line-height: 2rem;
}
